module.exports = __webpack_public_path__ + "img/logo-tecban-full.73d12502.png";